import React from 'react';
import { getDataIdGenerator } from '../../../core/utils/generateDataId';
import { GlobalSearchStateItem } from '../../interfaces/global-search';
import { GlobalSearchEntityListHeader } from '../GlobalSearchEntityListHeader';
import { GlobalSearchEntityListItem } from '../GlobalSearchEntityListItem/GlobalSearchEntityListItem';
import { GlobalSearchEntityListItemContent } from '../GlobalSearchEntityListItemContent';
import { GlobalSearchEntityListShimmer } from '../GlobalSearchShimmer';

export interface GlobalSearchEntitiesProps {
  entityType: string;
  entity: GlobalSearchStateItem;
}

export function GlobalSearchEntityList({
  entityType,
  entity,
}: GlobalSearchEntitiesProps) {
  const showLoadingShimmer = entity.loadingData;
  const showEntities = !showLoadingShimmer && entity.filteredEntities.length > 0;
  const dataIdGenerator = getDataIdGenerator('list')
  return (
    <div data-id={dataIdGenerator(entityType)}>
      <GlobalSearchEntityListHeader
        entityType={entityType}
        showCTA={!showLoadingShimmer}
        entity={entity}
      />

      {showLoadingShimmer ? (
        <GlobalSearchEntityListShimmer />
      ) : null}

      {showEntities
        ? entity.filteredEntities.map((filteredEntity) => (
          <GlobalSearchEntityListItem
            key={filteredEntity.key}
            entity={filteredEntity}
            entityType={entityType}
          >
            <GlobalSearchEntityListItemContent
              entity={entity}
              entityItem={filteredEntity}
            />
          </GlobalSearchEntityListItem>
        ))
        : null}
    </div>
  );
}
